'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-legend/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LOC = _sdk2.default.LOC;
var ref = _sdk2.default.shapes;
var Layer = ref.Layer;
var Rect = ref.Rect;
var Point = ref.Point;
var Text = ref.Text;
var ShapeGroup = ref.ShapeGroup;
var Line = ref.Line;
var ref$1 = _sdk2.default.utils;
var constants = ref$1.constants;
var plotUtils = ref$1.plotUtils;
var ref$2 = _sdk2.default.color;
var LinearGradient = ref$2.LinearGradient;
var MARK_TYPE = constants.MARK_TYPE;
var LEGEND = constants.LEGEND;
var NULL_KEY = constants.NULL_KEY;
var BAR = MARK_TYPE.BAR;
var LINE = MARK_TYPE.LINE;
var DOT = MARK_TYPE.DOT;
var legendPadding = LEGEND.PADDING;

var ColorLegend = function (AbstractLegend) {
  function ColorLegend() {
    AbstractLegend.apply(this, arguments);
  }

  if (AbstractLegend) ColorLegend.__proto__ = AbstractLegend;
  ColorLegend.prototype = (0, _create2.default)(AbstractLegend && AbstractLegend.prototype);
  ColorLegend.prototype.constructor = ColorLegend;

  ColorLegend.prototype.getDefaultConfig = function getDefaultConfig() {
    return _core2.default.extend(AbstractLegend.prototype.getDefaultConfig.call(this), {
      showPoints: false,
      mark: constants.MARK_TYPE.BAR,
      domain: []
    });
  };

  ColorLegend.prototype.getVerticalSize = function getVerticalSize() {
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var headerSize = this.getHeaderSize(true);
    var width = [headerSize[0]];
    var height = headerSize[1];
    var labels = config.labels || config.domain || [];
    labels.forEach(function (label) {
      width.push(plotUtils.getTextWidth(label) + config.swatchSize + 2 * config.swatchPadding);
      height += config.swatchSize + config.swatchPadding;
    });
    return [Math.max.apply(Math, width), height];
  };

  ColorLegend.prototype.getHorizontalSize = function getHorizontalSize(chartSize) {
    if (chartSize === void 0) chartSize = [0, 0];
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var width = this.getHeaderSize(false)[0];
    var height = config.swatchSize + config.swatchPadding;
    var labels = config.labels || config.domain || [];
    var marks = config.marks;
    labels.forEach(function (label, i) {
      // padding + swatch + padding + label + padding
      width += plotUtils.getTextWidth(label) + config.swatchSize + 3 * config.swatchPadding / 2;
      var mark = marks && marks[i] || config.mark;

      if (mark === LINE) {
        width += config.swatchPadding;
      }
    }); // if the legend is going to scroll then add padding for the scroll bar

    if (width > chartSize[0]) {
      height += 15;
    }

    return [width, height];
  };

  ColorLegend.prototype.plotFunction = function plotFunction(plot) {
    var config = this.config;
    var hotSpots = config.hotSpots;
    var columnName = config.columnName;
    var domain = config.domain;
    var unsortedDomain = config.unsortedDomain;
    var labels = config.labels;
    var colors = config.colors;
    var marks = config.marks;
    var showPoints = config.showPoints;
    var selectMode = config.selectMode;
    var transforms = config.transforms;
    var swatchSize = config.swatchSize;
    var fitHeight = config.fitHeight;
    var fitWidth = config.fitWidth;
    var theme = config.theme;
    var sorting = config.sorting;
    var padding = config.swatchPadding;
    var horizontalLayout = transforms.rotate;
    var canSelect = selectMode && selectMode !== constants.SELECTMODE.NONE;
    var plotLayer = new Layer({
      cell: plot,
      key: "plot",
      canHover: true,
      canSelect: canSelect
    });
    var scene = plot.getScene(); // fit or fix size on non-scrolling direction

    var fitForNonScroll = horizontalLayout ? fitHeight : fitWidth; // fit or fix size on scrolling direction

    var fitForScroll = horizontalLayout ? fitWidth : fitHeight; // draw legend items
    // horizontalLayout layout legend, text and swatch distance is padding/2

    var rowHeight = horizontalLayout ? swatchSize + padding : swatchSize + padding;

    if (hotSpots) {
      var hotSpotColors = theme.getHotspotColors();
      hotSpots = hotSpots.map(function (hotSpot) {
        hotSpot.size = swatchSize + padding;
        hotSpot.colors = _core2.default.defaults(hotSpot.colors, hotSpotColors);
        return hotSpot;
      });
    }

    var domainForLegend; // UnsortedDomain can be undefined if it is from Plots.
    // For bins, the domain is sorted already.  So, it doesn't matter if type is "VALUES" or ROWS
    // "VALUES" is like alphabetical.  "ROWS" is data rows thus, mirroring the chart results

    unsortedDomain = unsortedDomain || domain;

    if (!sorting || sorting && sorting.type !== constants.SORT.TYPE.ROWS) {
      domainForLegend = unsortedDomain.slice().sort();
    } else {
      domainForLegend = unsortedDomain;
    } // Reverse the legend for descending order


    if (sorting && sorting.order === constants.SORT.ORDER.DESC) {
      domainForLegend = domainForLegend.slice().reverse();
    }

    var width = plot.get("w");
    domainForLegend.forEach(function (name) {
      var obj;
      var data;
      var index = domain.indexOf(name);

      if (columnName) {
        data = {
          row: (obj = {}, obj[columnName] = name, obj),
          column: columnName
        };
      }

      if (name == undefined) {
        name = NULL_KEY;
      }

      var shapeGroup = new ShapeGroup({
        layer: plotLayer,
        key: name,
        data: data
      });
      var mark = marks && marks[index] || config.mark;
      var color = colors[index % colors.length]; // if we have a gradient color, get the middle color

      color = color instanceof LinearGradient ? color.interpolate() : color;
      var label = labels ? labels[index] : name;
      var rightPad = padding / 2; // mark shape is not hoverable since color would change, which may reflect
      // wrong color coding information

      switch (mark) {
        case DOT:
          new Point({
            shapeGroup: shapeGroup,
            key: name + "_dot",
            x: horizontalLayout ? width / 2 + rightPad : rightPad + swatchSize / 2,
            y: horizontalLayout ? rightPad + swatchSize / 2 : 0,
            r: swatchSize / 2,
            fill: color,
            canHover: false,
            skipInFind: true
          });
          break;

        case BAR:
          new Rect({
            shapeGroup: shapeGroup,
            key: name + "_bar",
            x: horizontalLayout ? width / 2 - swatchSize + padding + 1 : rightPad,
            y: horizontalLayout ? rightPad : -swatchSize / 2,
            w: swatchSize,
            h: swatchSize,
            cornerRadius: 3,
            fill: color,
            canHover: false,
            skipInFind: true
          });
          break;

        case LINE:
          {
            var length = swatchSize + padding;
            var offset = padding / 2;
            var lineProps = horizontalLayout ? {
              x0: width / 2 + constants.LEGEND.TEXT.SIZE / 2 - 2,
              y0: Math.round(offset),
              x1: width / 2 + constants.LEGEND.TEXT.SIZE / 2 - 2,
              y1: Math.round(length + offset)
            } : {
              x0: padding / 2,
              y0: 0,
              x1: Math.round(length),
              y1: 0
            };
            new Line(_core2.default.extend({
              shapeGroup: shapeGroup,
              key: name + "_line",
              stroke: color,
              lineWidth: 3,
              canHover: false,
              skipInFind: true
            }, lineProps));

            if (showPoints) {
              var pointProps = horizontalLayout ? {
                x: width / 2 + constants.LEGEND.TEXT.SIZE / 2 - 2,
                y: Math.round(offset + length / 2)
              } : {
                x: Math.round(-1 + (length + padding / 2) / 2),
                y: 0.5
              };
              new Point(_core2.default.extend({
                shapeGroup: shapeGroup,
                key: name + "_point",
                r: 4,
                fill: color,
                canHover: false,
                skipInFind: true
              }, pointProps));
            }

            break;
          }
      }

      var vPad = (rowHeight - new Text().getH()) / 2;
      var leftPad = horizontalLayout ? mark === LINE ? swatchSize + padding * 2 : swatchSize + padding : swatchSize + 1.5 * padding;
      var textProps = horizontalLayout ? {
        vertical: true,
        valign: "middle",
        y: 0,
        halign: "right"
      } : {
        maxWidth: plot.get("w"),
        valign: "middle",
        y: 0,
        halign: "left"
      };
      var text = new Text(_core2.default.extend({
        key: name + "_label",
        x: horizontalLayout ? width / 2 - constants.LEGEND.TEXT.SIZE + swatchSize + padding / 2 - 1 : 0,
        padding: {
          left: leftPad,
          right: rightPad,
          top: vPad,
          bottom: vPad
        },
        stroke: theme.getLegendTextColor(),
        hoverStroke: theme.getLegendTextHoverColor(),
        text: label,
        hotSpots: hotSpots,
        canSelect: true,
        data: data
      }, textProps)).prependTo(shapeGroup);

      if (horizontalLayout) {
        shapeGroup.offsetX(-padding / 2);
      } else {
        var bb = text.boundingBox();
        text.offsetY(-bb.y - bb.h / 2);
        shapeGroup.offsetY(rowHeight / 2);
      }
    }); // layout legend items

    plotLayer.applyLayout({
      type: "vbox"
    }); // compact legend grid
    // - on scrolling dimension

    if (fitForScroll) {
      scene.adjustRowToFit(plot.get("row"));
    } // - on non-scrolling dimension


    if (fitForNonScroll) {
      scene.adjustColumnToFit(plot.get("column"));
    } // background highlight for each legend tile


    plotLayer.forEach(function (group) {
      group.shapeByKey(group.key + "_label").set({
        hoverBgColor: theme.getLegendTextBGColor(),
        maxWidth: horizontalLayout ? group.boundingBox().h : plot.get("w")
      });
    });
  };

  return ColorLegend;
}(_index2.default);

exports.default = ColorLegend;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;